import {setCookie, getCookie, updateHeaderHeight} from "./kp-util";

const announcement_bar = document.querySelector('#announcement-bar')
const close_btn = document.querySelector('#announcement-close')

if (announcement_bar) {
    const hash = announcement_bar.dataset.hash
    const expiry = parseInt(announcement_bar.dataset.expiry)
    const closed_cookie = getCookie('closed_announcement')
    if (hash !== closed_cookie) {
        announcement_bar.classList.remove('hidden')
        updateHeaderHeight()
    }
    if (close_btn) {
        close_btn.addEventListener('click', e => {
            setCookie('closed_announcement', hash, expiry);
            document.body.classList.add('hide-announcement');
            announcement_bar.classList.add('hidden')
            updateHeaderHeight()
        })
    }
}
